"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const DrawIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.5227 3.50965C23.002 2.98895 22.1578 2.98895 21.6371 3.50965L5.40665 19.7401L2.92681 27.2085L2.66663 27.9999C2.66663 28.7363 3.26358 29.3333 3.99996 29.3333L28 29.3333C28.7363 29.3333 29.3333 28.7363 29.3333 27.9999C29.3333 27.2636 28.7363 26.6666 28 26.6666H11.1127L12.0063 26.3397L28.2367 10.1093C28.7574 9.58861 28.7574 8.74439 28.2367 8.22369L23.5227 3.50965ZM22.3189 6.59908L25.1473 9.42751L11.1941 23.3807L6.55984 25.1866L8.36561 20.5524L22.3189 6.59908Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.DrawIcon = DrawIcon;
//# sourceMappingURL=draw_icon.js.map